import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8 bg-navy" }
const _hoisted_2 = { class: "card-body d-flex flex-column flex-md-row align-items-center gap-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "d-flex flex-column gap-3 align-items-start" }
const _hoisted_5 = { class: "text-white fw-bolder fs-2x" }
const _hoisted_6 = { class: "d-flex flex-column flex-md-row gap-4" }
const _hoisted_7 = { class: "text-white fs-5 bg-white bg-opacity-15 rounded py-2 px-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt text-white fs-4" }, null, -1)
const _hoisted_9 = { class: "text-white fs-5 bg-white bg-opacity-15 rounded py-2 px-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2 text-white fs-4 me-2" }, null, -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "text-white fs-5 bg-white bg-opacity-15 rounded py-2 px-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people text-white fs-4" }, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_16 = { class: "row g-10" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "h4 pb-2 mb-5 text-fprimary border-bottom border-danger" }
const _hoisted_19 = { class: "text-center fw-bold my-4" }
const _hoisted_20 = {
  key: 1,
  class: "alert alert-danger text-center fw-bold mb-5"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill fs-3 me-2 text-danger" }, null, -1)
const _hoisted_22 = {
  key: 2,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_23 = { class: "alert-heading" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 3,
  class: "d-flex flex-column"
}
const _hoisted_26 = { class: "text-center fw-bold my-4" }
const _hoisted_27 = { class: "fw-bolder" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "col-sm-8" }
const _hoisted_32 = { class: "card mb-5 mb-xxl-8 d-none" }
const _hoisted_33 = { class: "card-body pt-9 pb-0" }
const _hoisted_34 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_35 = { class: "me-7" }
const _hoisted_36 = { class: "symbol symbol-150px symbol-lg-150px symbol-fixed position-relative" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "flex-grow-1" }
const _hoisted_39 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_40 = { class: "d-flex flex-column" }
const _hoisted_41 = { class: "d-flex align-items-center mb-2" }
const _hoisted_42 = { class: "text-fprimary fs-2 fw-bolder me-1" }
const _hoisted_43 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_45 = { class: "d-flex flex-column" }
const _hoisted_46 = { class: "fw-bolder" }
const _hoisted_47 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-week fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_49 = { class: "d-flex flex-column" }
const _hoisted_50 = { class: "fw-bolder" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = {
  key: 0,
  class: "d-flex flex-row align-items-center mb-4"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_54 = { class: "d-flex flex-column" }
const _hoisted_55 = { class: "fw-bolder" }
const _hoisted_56 = {
  key: 1,
  class: "d-flex flex-row align-items-center mb-4"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-text fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = {
  key: 0,
  class: "d-flex overflow-auto h-55px"
}
const _hoisted_61 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_62 = { class: "nav-item" }
const _hoisted_63 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_64 = {
  key: 1,
  class: "nav-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_btnBack = _resolveComponent("btnBack")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Attendees = _resolveComponent("Attendees")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VisorFile = _resolveComponent("VisorFile")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_image, {
          class: "w-150px h-150px rounded bg-white",
          src: _ctx.evento?.logo,
          fit: 'fill'
        }, {
          error: _withCtx(() => [
            _createElementVNode("img", {
              class: "",
              src: _ctx.myCompany?.avatar_vertical,
              style: {"width":"100%","height":"100%","object-fit":"fill"}
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_btnBack, {
            to: `/${_ctx.company?.alias.toLowerCase()}/tournaments`,
            className: "bg-white bg-opacity-15 text-white rounded p-2 d-inline-block px-4"
          }, null, 8, ["to"]),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.evento.name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.evento?.place), 1)
            ]),
            _createElementVNode("span", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", {
                innerHTML: _ctx.dateParticipate(_ctx.evento?.startdate, _ctx.evento?.enddate)
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("span", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.evento?.modality == 'V' ? 'Virtual' : 'Presencial'), 1)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    (_ctx.evento?.iscompetition == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    (_ctx.evento?.iscompetition == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('moreInformation')), 1),
              (_ctx.evento?.register == 1 && _ctx.evento?.deadline)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.t('labelDeadLine')), 1),
                    _createVNode(_component_CountDown, {
                      fechafin: _ctx.evento?.deadline,
                      "class-name": "text-center border rounded bg-success h6 fw-normal text-white mb-5",
                      "class-text": "mb-0 fw-bolder",
                      subtitle: "font-size:10px;",
                      dangerClass: "mb-2"
                    }, null, 8, ["fechafin"])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(_toDisplayString(_ctx.t('acrd11')), 1)
                  ])),
              (_ctx.evento?.note)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.t('notice')) + "!", 1),
                    _createElementVNode("p", {
                      innerHTML: _ctx.evento?.note
                    }, null, 8, _hoisted_24)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.listDocs.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("h5", _hoisted_26, _toDisplayString(_ctx.t('documentation')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDocs, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "item d-flex justify-content-between border border-warning shadow-sm p-4 rounded mb-5 bg-light-warning align-items-center bg-hover-warning"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(item.nombre), 1),
                          _hoisted_28
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.openVisorFile(item.ruta)),
                            target: "_blank",
                            class: "btn btn-sm bg-white border border-warning text-hover-warning me-3"
                          }, _toDisplayString(_ctx.t('viewFile')), 9, _hoisted_30)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
                    key: 4,
                    description: `${_ctx.t('notFoundResult')}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.getDocuments
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["description"])), [
                    [_directive_loading, _ctx.loader]
                  ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Attendees, {
                event: _ctx.evento,
                activity: _ctx.activity
              }, null, 8, ["event", "activity"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_el_image, {
                class: "w-200px h-200px rounded",
                src: _ctx.evento?.logo,
                fit: 'fill'
              }, {
                error: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "",
                    src: _ctx.myCompany?.avatar_vertical,
                    style: {"width":"100%","height":"100%","object-fit":"fill"}
                  }, null, 8, _hoisted_37)
                ]),
                _: 1
              }, 8, ["src"])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.evento.name), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.t("place")), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.evento?.place), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.t("date")), 1),
                    _createElementVNode("span", {
                      innerHTML: _ctx.dateParticipate(_ctx.evento?.startdate, _ctx.evento?.enddate)
                    }, null, 8, _hoisted_51)
                  ])
                ]),
                (_ctx.evento?.modality)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.t("modality")), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.evento?.modality == 'V' ? 'Virtual' : 'Presencial'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.evento?.note && _ctx.evento?.iscompetition == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("p", {
                        innerHTML: _ctx.evento?.note,
                        class: "m-0"
                      }, null, 8, _hoisted_58)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_btnBack, {
                  to: `/${_ctx.company?.alias.toLowerCase()}/tournaments`
                }, null, 8, ["to"])
              ])
            ])
          ])
        ]),
        (_ctx.evento?.iscompetition == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _createElementVNode("ul", _hoisted_61, [
                _createElementVNode("li", _hoisted_62, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: `/${_ctx.company?.alias.toLowerCase()}/tournaments/${_ctx.id}/manager/home`,
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("home")), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                (_ctx.evento.forms == 1)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_63, [
                      _createVNode(_component_router_link, {
                        class: "nav-link text-active-primary me-6",
                        to: `/${_ctx.company?.alias.toLowerCase()}/tournaments/${_ctx.id}/manager/forms`,
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("forms")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.evento.forms != 1)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_64, [
                      _createVNode(_component_router_link, {
                        class: "nav-link text-active-primary me-6",
                        to: `/${_ctx.company?.alias.toLowerCase()}/tournaments/${_ctx.id}/manager/sports`,
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("sports")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_VisorFile)
  ], 64))
}